import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  success(message) {
    Toast.fire({
      icon: "success",
      title: message,
    });
  },

  error(message) {
    Toast.fire({
      icon: "error",
      title: message,
    });
  },

  info(message) {
    Toast.fire({
      icon: "warning",
      title: message,
    });
  },
};
